import styled from "styled-components";
import { useTranslation } from "../../lang/TranslationContext";
import { AnimateIn } from "../../components/AnimateIn";
import { lightTheme } from "../../styles/theme";

export const TrustMetrics = () => {
  const { translations } = useTranslation();

  return (
    <Wrap>
      <Container>
        <AnimateIn>
          <Heading>{translations.landing.trust.heading}</Heading>
        </AnimateIn>
        <MetricsGrid>
          <AnimateIn msDelay={100}>
            <MetricCard>
              <MetricValue>
                {translations.landing.trust.metric1Value}
              </MetricValue>
              <MetricLabel>
                {translations.landing.trust.metric1Label}
              </MetricLabel>
            </MetricCard>
          </AnimateIn>
          <AnimateIn msDelay={200}>
            <MetricCard>
              <MetricValue>
                {translations.landing.trust.metric2Value}
              </MetricValue>
              <MetricLabel>
                {translations.landing.trust.metric2Label}
              </MetricLabel>
            </MetricCard>
          </AnimateIn>
          <AnimateIn msDelay={300}>
            <MetricCard>
              <MetricValue>
                {translations.landing.trust.metric3Value}
              </MetricValue>
              <MetricLabel>
                {translations.landing.trust.metric3Label}
              </MetricLabel>
            </MetricCard>
          </AnimateIn>
          <AnimateIn msDelay={400}>
            <MetricCard>
              <MetricValue>
                {translations.landing.trust.metric4Value}
              </MetricValue>
              <MetricLabel>
                {translations.landing.trust.metric4Label}
              </MetricLabel>
            </MetricCard>
          </AnimateIn>
          <AnimateIn msDelay={500}>
            <MetricCard>
              <MetricValue>
                {translations.landing.trust.metric5Value}
              </MetricValue>
              <MetricLabel>
                {translations.landing.trust.metric5Label}
              </MetricLabel>
            </MetricCard>
          </AnimateIn>
        </MetricsGrid>
      </Container>
    </Wrap>
  );
};

const Wrap = styled.div`
  background: #fcfdff;
  padding: 80px 24px;

  @media screen and (max-width: 700px) {
    padding: 60px 16px;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Heading = styled.h2`
  font-size: 36px;
  font-weight: 700;
  text-align: center;
  color: ${lightTheme.typography.primary};
  margin-bottom: 60px;

  @media screen and (max-width: 700px) {
    font-size: 28px;
    margin-bottom: 40px;
  }
`;

const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 32px;

  @media screen and (max-width: 1150px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 710px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 500px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

const MetricCard = styled.div`
  background: white;
  padding: 32px 24px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: 0.3s;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
  }
`;

const MetricValue = styled.div`
  font-size: 42px;
  font-weight: 800;
  color: #047857;
  margin-bottom: 8px;

  @media screen and (max-width: 700px) {
    font-size: 36px;
  }
`;

const MetricLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${lightTheme.typography.secondary};
`;
